import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-flex-faqs',
    templateUrl: './block-flex-faqs.component.html',
})

export class BlockFAQsComponent extends BlockAbstractComponent implements OnInit {

}
